
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post33() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Oi pessoal, 
Estou com pressão elevada fazem dias já, e tenho ido no pronto socorro por causa disso. Lá eles me receitam captopril e me mandam pra casa.
Está desesperador isso. Se vocês já passaram por isso, que chá vocês tomam que possa ajudar?
Obrigado!</title>
        <meta 
          name="description" 
          content="Oi pessoal, 
Estou com pressão elevada fazem dias já, e tenho ido no pronto socorro por causa disso. Lá eles me receitam captopril e me mandam pra casa.
Está desesperador isso. Se vocês já passaram por isso, que chá vocês tomam que possa ajudar?
Obrigado!"/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            Maria Meyer &#183; 07/08/2024
          </p>
        </div>


        <p className="body content bottom-padding-s">
            Oi pessoal, <br/>Estou com pressão elevada fazem dias já, e tenho ido no pronto socorro por causa disso. Lá eles me receitam captopril e me mandam pra casa.<br/>Está desesperador isso. Se vocês já passaram por isso, que chá vocês tomam que possa ajudar?<br/>Obrigado!
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/33')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  2 pessoas acharam útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Olá!<br/><br/>Lamento que você esteja passando por essa situação com sua pressão. É importante seguir as orientações médicas, como o uso do captopril conforme prescrito. Mas entendo sua procura por alternativas que possam complementar o tratamento.<br/><br/>Alguns chás são conhecidos por suas propriedades que podem auxiliar na redução da pressão arterial, como o chá de hibisco e o chá verde. No entanto, é fundamental ter cautela, pois nem todos podem ser seguros ou adequados para a sua condição específica. Por exemplo, o chá verde pode interferir com certos medicamentos e o hibisco pode ser muito potente para algumas pessoas, causando diminuição da pressão arterial para níveis mais baixos do que o desejado.<br/><br/>Antes de iniciar qualquer novo tratamento alternativo, por mais natural que pareça ser, recomendo que você converse com seu médico. Ele poderá orientá-la melhor sobre a segurança desses chás em seu caso específico, considerando os medicamentos que você já usa e sua condição de saúde geral.<br/><br/>Além disso, outras práticas podem ajudar a gerenciar a pressão alta, como manter uma alimentação saudável, rica em frutas, verduras e baixa em sal, praticar atividades físicas regulares, manter o peso saudável, evitar o consumo excessivo de álcool e não fumar.<br/><br/>Se sua pressão continuar elevada mesmo após seguir as orientações médicas, é importante voltar ao médico para reavaliar o tratamento. Cuidar da pressão alta exige uma abordagem abrangente, que inclui medicamentos, mudanças no estilo de vida e, às vezes, remédios ou tratamentos complementares com segurança e sob orientação médica.<br/><br/>Estou aqui para qualquer outra dúvida ou apoio que precisar. Cuide-se!
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 07/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/33')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Mario César &#183; 15/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/97-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. Estou bastante triste, descobri que estou com catarata por conta da diabete segundo o oftalmologista. Não consigo entender muito bem, mantenho a glicose controlada, jejum 105, prandial deu até menos, 100 glicada 6.4. Estou preocupado.
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/97')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            6 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Danna Rosa &#183; 08/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/45-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal, boa tarde. Me tirem uma dúvida.<br/>Diabético pode usar açúcar mascavo no lugar do açúcar normal?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/45')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    T. Estudante &#183; 24/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/11-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Diabetes: Minha experiência medindo glicose em casa  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Após o diagnóstico com diabetes, a melhor coisa que fiz foi comprar um medidor de glicose, aprender a usar e medir todos os dias. Recomendo para todos sempre. Acredito que esse seja o melhor jeito para aprender a controlar a diabetes.<br/><br/>Dica: para mim, o melhor lugar para espetar o dedo é nos lados das pontas, perto das unhas (mas não muito perto).<br/><br/>Teste sua glicose com a maior frequência que você conseguir: Isso é especialmente importante no início, quando você está aprendendo como seu corpo reage às diferentes comidas e os exercícios físicos que você faz.<br/><br/>A maioria das pessoas gosta de medir quando levantam de manhã. Isso é chamado de teste de jejum, e dá uma indicação de quão bom foi o seu controle no dia anterior.<br/><br/>Outros horários comuns para testar:<br/><br/>1) Uma ou duas horas depois de uma refeição: o resultado mostra quão alto a sua glicose sobre quando você come aquelas comidas em particular. Toda a comida que você põe na boca influencia o nível de glicose, e é importante entender como é essa influência.<br/><br/>2) Antes da próxima refeição: o resultado mostra se a subida da glicose da refeição anterior já desceu para o patamar normal antes da próxima refeição.<br/><br/>3) Antes e depois de exercício.<br/><br/>4) Na hora de dormir.<br/><br/>5) A qualquer momento que você acha que tem algo de errado.<br/><br/>É legal rotacionar os horários de teste ao longo dos dias para conseguir mais informações.<br/><br/>Após mais ou menos um ano com esse treinamento intensivo, eu tinha um bom conhecimento de como meu corpo reagia as várias coisas, e pude reduzir a frequência das medições.<br/><br/>Por fim, registre e guarde os resultados das medições (no caderno, no computador ou no excel, onde você quiser), e também tenha cópia de todos os seus exames. Ter esses registros vai fazer com que você estude mais para entendê-los e vai te ajudar a saber como está a sua condição ao longo do tempo. No longo prazo, esse registros valem ouro!<br/><br/>Espero que isso possa ajudar quem está começando sua jornada com diabetes!<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/11')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Gabrielli Machado &#183; 11/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/70-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Alguém pra indicar um adoçante que seja melhor pra quem tem diabetes?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/70')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Caroline Pereira &#183; 11/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/71-diabetes" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal. Estou com glicose em jejum de 151 tomando glifage 1x ao dia. É muito ruim?<br/>A médica havia me receitado 2x ao dia, mas eu estava muito ruim com os primeiros sintomas, e diminui para 1x pela manhã.<br/>Obrigado!
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/71')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
